var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { class: ["sidebar", { collapsed: !_vm.isSidebarOpen }] }, [
    _c("div", { staticClass: "sidebar-header" }, [
      _vm.isSidebarOpen ? _c("h3", [_vm._v("Navigation")]) : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-panel", on: { click: _vm.togglePanel } },
        [
          _c("i", {
            class: _vm.isSidebarOpen
              ? "fa-solid fa-chevron-left"
              : "fa-solid fa-chevron-right",
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.isSidebarOpen
      ? _c("ul", [
          _c(
            "li",
            {
              class: { active: _vm.page === "dashboard" },
              on: {
                click: function ($event) {
                  return _vm.navigate("dashboard")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-house" }),
              _vm._v("Dashboard\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.page === "simulation" },
              on: {
                click: function ($event) {
                  return _vm.navigate("simulation")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-server" }),
              _vm._v("API Simulation\n    "),
            ]
          ),
        ])
      : _c("ul", [
          _c(
            "li",
            {
              class: { active: _vm.page === "dashboard" },
              attrs: { title: "Dashboard" },
              on: {
                click: function ($event) {
                  return _vm.navigate("dashboard")
                },
              },
            },
            [_c("i", { staticClass: "fa-light fa-house" })]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.page === "simulation" },
              on: {
                click: function ($event) {
                  return _vm.navigate("simulation")
                },
              },
            },
            [_c("i", { staticClass: "fa-light fa-server" })]
          ),
        ]),
    _vm._v(" "),
    _vm.isSidebarOpen ? _c("span", [_vm._v("Reconciliation")]) : _vm._e(),
    _vm._v(" "),
    _vm.isSidebarOpen
      ? _c("ul", [
          _c(
            "li",
            {
              class: { active: _vm.page === "vibanmanagement" },
              on: {
                click: function ($event) {
                  return _vm.navigate("vibanmanagement")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-database" }),
              _vm._v("VIBAN Management\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.page === "reconciliationledger" },
              on: {
                click: function ($event) {
                  return _vm.navigate("reconciliationledger")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-user-check" }),
              _vm._v("Reconciliation Ledger\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: {
                active:
                  _vm.page === "transactionledger" ||
                  _vm.page.startsWith("/transactionledger"),
              },
              on: {
                click: function ($event) {
                  return _vm.navigate("transactionledger")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-file-magnifying-glass" }),
              _vm._v("Transaction Ledger\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.page === "dailyreport" },
              on: {
                click: function ($event) {
                  return _vm.navigate("dailyreport")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-calendar-check" }),
              _vm._v("Daily Report\n    "),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSidebarOpen ? _c("span", [_vm._v("Configuration")]) : _vm._e(),
    _vm._v(" "),
    _vm.isSidebarOpen
      ? _c("ul", [
          _c(
            "li",
            {
              class: { active: _vm.page === "configuration" },
              on: {
                click: function ($event) {
                  return _vm.navigate("configuration")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-wave-pulse" }),
              _vm._v("Reconciliation Rules\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.page === "usermanagement" },
              on: {
                click: function ($event) {
                  return _vm.navigate("usermanagement")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-user-group" }),
              _vm._v("User Management\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.page === "auditlogs" },
              on: {
                click: function ($event) {
                  return _vm.navigate("auditlogs")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-file-magnifying-glass" }),
              _vm._v("Audit Logs\n    "),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSidebarOpen ? _c("span", [_vm._v("Help")]) : _vm._e(),
    _vm._v(" "),
    _vm.isSidebarOpen
      ? _c("ul", [
          _c(
            "li",
            {
              class: { active: _vm.page === "documentation" },
              on: {
                click: function ($event) {
                  return _vm.navigate("documentation")
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-book-open" }),
              _vm._v("Documentation\n    "),
            ]
          ),
        ])
      : _c(
          "ul",
          _vm._l(_vm.collapsedItems, function (item) {
            return _c(
              "li",
              {
                key: item.page,
                class: { active: _vm.page === item.page },
                attrs: { title: item.label },
                on: {
                  click: function ($event) {
                    return _vm.navigate(item.url)
                  },
                },
              },
              [_c("i", { class: ["fa-light", item.icon] })]
            )
          }),
          0
        ),
    _vm._v(" "),
    _vm.isSidebarOpen
      ? _c("div", { staticClass: "stats" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c("span", [_vm._v("Automation Rate:")]),
            _c("span", [
              _vm._v(_vm._s(_vm.stats.AutomationRate.toFixed(2)) + "%"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", [_vm._v("Overdue Orders:")]),
            _c("span", [_vm._v(_vm._s(_vm.stats.NbOverdue))]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", [_vm._v("Today's Volume:")]),
            _c("span", [
              _vm._v("€" + _vm._s(_vm.stats.AmountReconciliation.toFixed(2))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", [_vm._v("Today's Reconciliations:")]),
            _c("span", [_vm._v(_vm._s(_vm.stats.NbReconciliation))]),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stats-title" }, [
      _c("h1", [_vm._v("Quick Stats")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Active Rule Config:")]),
      _c("span", [_vm._v("E-commerce Standard")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }